import { render, staticRenderFns } from "./canvass.vue?vue&type=template&id=32787376&scoped=true"
import script from "./canvass.vue?vue&type=script&lang=js"
export * from "./canvass.vue?vue&type=script&lang=js"
import style0 from "./canvass.vue?vue&type=style&index=0&id=32787376&prod&lang=scss"
import style1 from "./canvass.vue?vue&type=style&index=1&id=32787376&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32787376",
  null
  
)

export default component.exports